import React from 'react'
import Sidebar from './Sidebar'
import Footer from './Footer'
import { Outlet } from 'react-router-dom'

export default function Layout() {
  return (
      <div className="wrapper">
          {/* <!-- ========== Left Sidebar Start ========== --> */}
          <Sidebar />
          {/* <!-- Left Sidebar End --> */}
           <div className="content-page">
            <div className="content">
               {/* <!-- Start Content--> */}
                  <div className="container-fluid">
                      <Outlet /> 
               </div>
              </div>
              <Footer />
               </div>
    </div>
  )
}
